export enum SessionVariable {
  REQ_ID = 'reqID',
  OTP_REF = 'otpRef',
  REG_OTP = 'regOtp',
  USER_ID = 'userId',
  AUTO_PAY = 'autoPay',
  ORDER_ID = 'orderId',
  LANGUAGE = 'language',
  STORE_NAME = 'storeName',
  PAYMENT_ID = 'paymentId',
  NATIONAL_ID = 'nationalId',
  ACCESS_TOKEN = 'accessToken',
  AUTH_PROFILE = 'authProfile',
  SIGNUP_TOKEN = 'signupToken',
  COUNTRY_CODE = 'countryCode',
  PAYMENT_DATE = 'paymentDate',
  CREDIT_LIMIT = 'creditLimit',
  REFERENCE_ID = 'referenceId',
  MOBILE_NUMBER = 'mobileNumber',
  REFRESH_TOKEN = 'refresh_token',
  MERCHANT_BRAND = 'merchantBrand',
  PAYMENT_PLAN_ID = 'paymentPlanId',
  PAYMENT_OPTIONS = 'paymentOptions',
  FAIL_ERROR_MSG = 'failErrorMessage',
  PAID_BY_APPLE_PAY = 'paidByApplePay',
  ORDER_ID_FOR_CNET = 'orderIdForCnet',
  ORDER_DESCRIPTION = 'orderDescription',
  PAYMENT_REFERENCE = 'paymentReference',
  REGISTRATION_NUMBER = 'registrationNumber',
  IS_PAY_LATER_SELECTED = 'isPayLaterSelected',
  MAX_ORDER_VALUE_EXCEEDED = 'maxOrderValueExceeded',
  MINIMUM_ORDER_VALUE_MESSAGE = 'minimumOrderValueMessage',
  ARABIC_MINIMUM_ORDER_VALUE_MESSAGE = 'arabicMinimumOrderValueMessage',
}
